import { AutogenModelDetentionHistChg, AutogenRowDetentionHistChg } from "./autogen/AutogenModelDetentionHistChg";

export class ModelDetentionHistChg extends AutogenModelDetentionHistChg<RowDetentionHistChg> {
	constructor() {
		super(RowDetentionHistChg);
	}
}

export class RowDetentionHistChg extends AutogenRowDetentionHistChg {
}